module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [(!_vm.isClient) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "xs": "6",
      "md": "6"
    }
  }, [_c('v-btn', {
    staticClass: "mr-2 primary",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-file-excel")]), _vm._v("Export Excel\n      ")], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-row', {
    attrs: {
      "justify": "right",
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "d-flex flex-row",
    attrs: {
      "cols": "12",
      "md": "12",
      "lg": "12",
      "sm": "12",
      "align": "center",
      "justify": "center"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "filled": "",
      "items": _vm.campaigns,
      "label": "Campaign",
      "hide-details": "",
      "item-text": "name",
      "item-value": "id",
      "return-object": true,
      "clearable": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_vm._v("\n            " + _vm._s(item.name) + "  \n            "), (item.lockedCOGS && !_vm.isClient) ? _c('v-chip', {
          attrs: {
            "color": "error",
            "small": ""
          }
        }, [_c('span', {
          staticStyle: {
            "color": "#fff"
          }
        }, [_c('v-icon', _vm._g({
          attrs: {
            "small": "",
            "left": ""
          }
        }, _vm.on), [_vm._v("mdi-lock")]), _vm._v(" Locked COGS")], 1)]) : _vm._e()], 1)]
      }
    }]),
    model: {
      value: (_vm.filteredCampaign),
      callback: function($$v) {
        _vm.filteredCampaign = $$v
      },
      expression: "filteredCampaign"
    }
  })], 1)], 1), _vm._v(" "), _c('v-row', {
    staticClass: "pt-0"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "sm": "7",
      "md": "7",
      "lg": "7"
    }
  }, [(!_vm.isClient) ? _c('div', {
    staticClass: "d-flex flex-row",
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-autocomplete', {
    staticStyle: {
      "min-width": "300px",
      "max-width": "300px",
      "padding-top": "10px"
    },
    attrs: {
      "items": _vm.filterStatuses,
      "item-value": "value",
      "item-text": "text",
      "label": "Status",
      "hide-details": "",
      "outlined": "",
      "dense": "",
      "clearable": ""
    },
    model: {
      value: (_vm.filters.status),
      callback: function($$v) {
        _vm.$set(_vm.filters, "status", $$v)
      },
      expression: "filters.status"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "sm": "5",
      "md": "5",
      "lg": "5"
    }
  }, [_c('div', {
    staticClass: "d-flex flex-row"
  }, [_c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filters.keyword),
      callback: function($$v) {
        _vm.$set(_vm.filters, "keyword", $$v)
      },
      expression: "filters.keyword"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 mt-4",
    attrs: {
      "color": "secondary",
      "small": ""
    },
    on: {
      "click": _vm.searchFilter
    }
  }, [_vm._v("Apply")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ml-2 mt-4",
    attrs: {
      "small": ""
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v("Reset")])], 1)])], 1), _vm._v(" "), (_vm.filteredCampaign && !_vm.isClient) ? _c('div', {
    staticClass: "text-right"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "bottom": "",
      "left": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;
        var attrs = ref.attrs;

        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "color": "secondary"
          },
          on: {
            "click": _vm.openColSettingsModal
          }
        }, 'v-btn', attrs, false), on), [_c('i', {
          staticClass: "fas fa-cog fa-lg",
          attrs: {
            "data-toggle": "tooltip",
            "data-placement": "top",
            "title": "Settings"
          }
        })])]
      }
    }], null, false, 1707098776)
  })], 1) : _vm._e(), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-1 creator_concept_page__table",
    attrs: {
      "headers": _vm.computedHeaders,
      "items": _vm.filteredItems,
      "item-key": "dataTableKey",
      "options": _vm.pagination,
      "server-items-length": _vm.totalItems,
      "footer-props": {
        itemsPerPageOptions: _vm.rowsPerPageItems
      },
      "items-per-page": 20,
      "no-data-text": 'Empty list'
    },
    on: {
      "update:options": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "item.userHandle",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "text-left"
        }, [_c('social-handle', {
          attrs: {
            "divClassName": "d-inline",
            "isTikTok": item.platform === 'tiktok',
            "isInstagram": item.platform === 'instagram',
            "isFacebook": item.platform === 'facebook',
            "isLinkedIn": item.platform === 'linkedin',
            "isTwitter": item.platform === 'twitter',
            "isYoutube": item.platform === 'youtube',
            "isXiaohongshu": item.platform === 'xiaohongshu',
            "tiktokHandle": item.userHandle,
            "instagramHandle": item.userHandle,
            "facebookHandle": item.userHandle,
            "linkedinHandle": item.userHandle,
            "twitterHandle": item.userHandle,
            "youtubeHandle": item.userHandle,
            "xiaohongshuHandle": item.xhsID,
            "xiaohongshuFullName": item.fullName,
            "youtubeURL": item.url
          }
        }), _vm._v(" "), (item.influencerID) ? _c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                attrs: {
                  "color": "green"
                },
                on: {
                  "click": true
                }
              }, on), [_vm._v("done")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Registered on IMS")])]) : _vm._e()], 1)]
      }
    }, {
      key: "item.campaignName",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "text-left"
        }, [_vm._v("\n            " + _vm._s(item.campaignName) + "\n          ")])]
      }
    }, {
      key: "item.conceptStatus",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', {
          staticClass: "text-left"
        }, [(item.conceptStatusEdit) ? _c('div', {
          staticClass: "d-flex flex-row"
        }, [_c('v-select', {
          staticStyle: {
            "max-width": "320px"
          },
          attrs: {
            "items": _vm.conceptStatuses,
            "item-text": "text",
            "item-value": "value",
            "hide-details": "",
            "dense": ""
          },
          on: {
            "change": _vm.changeConceptStatus
          },
          model: {
            value: (item.conceptStatus),
            callback: function($$v) {
              _vm.$set(item, "conceptStatus", $$v)
            },
            expression: "item.conceptStatus"
          }
        }), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateCreatorConcept(item, 'conceptStatus')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('conceptStatusEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.conceptStatusEdit) ? _c('v-chip', {
          attrs: {
            "color": _vm.conceptStatusClr(item.conceptStatus),
            "small": ""
          }
        }, [_c('span', {
          class: ("statusdisplay-" + (item.conceptStatus))
        }, [_vm._v(_vm._s(_vm.conceptStatusDisplay(item.conceptStatus)))])]) : _vm._e(), _vm._v(" "), (!item.conceptStatusEdit && _vm.isNotClient) ? _c('v-btn', {
          attrs: {
            "color": "secondary",
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('conceptStatusEdit', item, true)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "secondary",
            "title": "Update",
            "x-small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.contentScripts",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-right"
        }, [_c('div', {
          staticClass: "d-flex flex-row"
        }, [(item.contentScriptForm) ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.viewContentScriptDialog(item.pairingID)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
          attrs: {
            "color": "secondary",
            "small": ""
          }
        }, [_vm._v("edit")]), _vm._v(" "), (_vm.isClient) ? _c('span', [_vm._v("View")]) : _vm._e(), _vm._v(" "), (!_vm.isClient) ? _c('span', [_vm._v("Edit")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (item.contentScriptForm && !_vm.isClient) ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "success",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.downloadWord(item)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
          attrs: {
            "color": "success",
            "small": ""
          }
        }, [_vm._v("download")]), _vm._v(" Download\n              ")], 1) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.isClient) ? _c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "secondary",
            "small": "",
            "text": ""
          },
          on: {
            "click": function($event) {
              return _vm.copyContentScriptFormLink(item)
            }
          }
        }, 'v-btn', _vm.attrs, false), _vm.on), [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-content-copy+")]), _vm._v(" "), _c('span', [_vm._v("Copy link")])], 1) : _vm._e()], 1)], 1)])]
      }
    }, {
      key: "item.postingLink",
      fn: function(ref) {
        var item = ref.item;

        return [(item.postingLinkEdit) ? _c('div', {
          staticClass: "d-flex flex-row"
        }, [(item.postingLinkEdit) ? _c('v-text-field', {
          staticStyle: {
            "max-width": "320px"
          },
          attrs: {
            "dense": "",
            "hide-details": ""
          },
          model: {
            value: (item.postingLink),
            callback: function($$v) {
              _vm.$set(item, "postingLink", $$v)
            },
            expression: "item.postingLink"
          }
        }) : _vm._e(), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateCreatorConcept(item, 'postingLink')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('postingLinkEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.postingLinkEdit) ? _c('div', [_c('v-btn', {
          staticClass: "pa-0 ma-0",
          staticStyle: {
            "min-width": "20px"
          },
          attrs: {
            "text": "",
            "small": "",
            "color": "secondary",
            "href": item.postingLink,
            "target": '_blank',
            "disabled": !item.postingLink
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Link",
                  "small": ""
                }
              }, on), [_vm._v("mdi-link-variant")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("View Posting Link")])])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "text": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('postingLinkEdit', item, true)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Update",
                  "x-small": ""
                }
              }, on), [_vm._v("edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Posting Link")])])], 1)], 1) : _vm._e()]
      }
    }, {
      key: "item.shootDate",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-right"
        }, [(item.shootDateEdit) ? _c('div', [_c('div', {
          staticClass: "d-flex flex-row"
        }, [_c('v-text-field', {
          staticClass: "edit-date-box",
          attrs: {
            "outlined": "",
            "dense": "",
            "hide-details": ""
          },
          on: {
            "input": function($event) {
              return _vm.checkActDate(item, item.shootDate)
            },
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.checkActDate(item, item.shootDate)
            }
          },
          model: {
            value: (item.shootDate),
            callback: function($$v) {
              _vm.$set(item, "shootDate", $$v)
            },
            expression: "item.shootDate"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "date-picker-inner"
        }, [_c('date-picker', {
          attrs: {
            "className": "input-field",
            "options": {
              theme: 'icon',
              confirm: true
            },
            "status": item.actEndDateCal
          },
          on: {
            "changeDate": function($event) {
              var i = arguments.length, argsArray = Array(i);
              while ( i-- ) argsArray[i] = arguments[i];

              return _vm.setActDateFromPicker.apply(void 0, [ item ].concat( argsArray ))
            }
          }
        })], 1)], 1), _vm._v(" "), (item.shootDateEdit) ? _c('div', {
          staticClass: "d-flex flex-row justify-right"
        }, [_c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1 ml-1",
            "x-small": "",
            "disabled": item.invalidShootDate
          },
          on: {
            "click": function($event) {
              return _vm.updateCreatorConcept(item, 'shootDate')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('shootDateEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.shootDateEdit) ? _c('div', [_vm._v("\n              " + _vm._s(item.shootDate) + "\n              "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('shootDateEdit', item, true)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Update",
                  "x-small": ""
                }
              }, on), [_vm._v("edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Shoot Date")])])], 1)], 1) : _vm._e()])]
      }
    }, {
      key: "item.deliverableDetails",
      fn: function(ref) {
        var item = ref.item;

        return [_c('div', [_c('p', {
          staticClass: "deliverable-txt mb-0"
        }, [_vm._v("\n              " + _vm._s(_vm.campaignHelper.getDeliverableDetails(item.deliverableDetails)) + "\n            ")])])]
      }
    }, {
      key: "item.contentFeature",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-right pa-2"
        }, [(item.contentFeatureEdit) ? _c('v-textarea', {
          staticStyle: {
            "min-width": "150px",
            "max-width": "320px"
          },
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (item.contentFeature),
            callback: function($$v) {
              _vm.$set(item, "contentFeature", $$v)
            },
            expression: "item.contentFeature"
          }
        }) : _vm._e(), _vm._v(" "), (item.contentFeatureEdit) ? _c('div', {
          staticClass: "d-flex flex-row justify-right"
        }, [_c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateCreatorConcept(item, 'contentFeature')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('contentFeatureEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.contentFeatureEdit) ? _c('div', [_vm._v("\n              " + _vm._s(item.contentFeature) + "\n              "), (!_vm.isClient) ? _c('v-btn', {
          attrs: {
            "color": "secondary",
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('contentFeatureEdit', item, true)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Update",
                  "x-small": ""
                }
              }, on), [_vm._v("edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Content feature/pillar")])])], 1) : _vm._e()], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.kobeRemark",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-right pa-2"
        }, [(item.kobeRemarkEdit) ? _c('v-textarea', {
          staticStyle: {
            "min-width": "150px",
            "max-width": "320px"
          },
          attrs: {
            "dense": "",
            "outlined": "",
            "hide-details": ""
          },
          model: {
            value: (item.kobeRemark),
            callback: function($$v) {
              _vm.$set(item, "kobeRemark", $$v)
            },
            expression: "item.kobeRemark"
          }
        }) : _vm._e(), _vm._v(" "), (item.kobeRemarkEdit) ? _c('div', {
          staticClass: "d-flex flex-row justify-right"
        }, [_c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "success btn-edit-mth mr-1",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.updateCreatorConcept(item, 'kobeRemark')
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("check")])], 1), _vm._v(" "), _c('v-btn', {
          staticStyle: {
            "margin-top": "7px"
          },
          attrs: {
            "color": "red btn-edit-mth",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('kobeRemarkEdit', item, false)
            }
          }
        }, [_c('v-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "color": "white",
            "title": "Close",
            "x-small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), (!item.kobeRemarkEdit) ? _c('div', [_c('v-tooltip', {
          attrs: {
            "bottom": "",
            "color": "black",
            "max-width": "300px"
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('div', _vm._g({}, on), [_c('p', {
                staticClass: "remark-text"
              }, [_vm._v(_vm._s(item.kobeRemark || '-'))])])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDesc(item.kobeRemark))
          }
        })]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "color": "secondary",
            "icon": "",
            "x-small": ""
          },
          on: {
            "click": function($event) {
              return _vm.changeCreatorConceptEdit('kobeRemarkEdit', item, true)
            }
          }
        }, [_c('v-tooltip', {
          attrs: {
            "bottom": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function(ref) {
              var on = ref.on;

              return [_c('v-icon', _vm._g({
                staticClass: "cursor-pointer",
                attrs: {
                  "color": "secondary",
                  "title": "Update",
                  "x-small": ""
                }
              }, on), [_vm._v("edit")])]
            }
          }], null, true)
        }, [_vm._v(" "), _c('span', [_vm._v("Edit Content feature/pillar")])])], 1)], 1) : _vm._e()], 1)]
      }
    }, {
      key: "item.action",
      fn: function(ref) {
        var item = ref.item;

        return [_c('td', {
          staticClass: "text-center",
          staticStyle: {
            "width": "170px"
          }
        }, [(item.releaseContentScript) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "error"
          },
          on: {
            "click": function($event) {
              return _vm.changeRelease(item, false)
            }
          }
        }, [_vm._v("\n              Suspend\n              "), _c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-close-circle")])], 1) : _vm._e(), _vm._v(" "), (!item.releaseContentScript) ? _c('v-btn', {
          attrs: {
            "small": "",
            "color": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.changeRelease(item, true)
            }
          }
        }, [_vm._v("\n              Release\n              "), _c('v-icon', {
          attrs: {
            "color": "white",
            "small": ""
          }
        }, [_vm._v("mdi-check")])], 1) : _vm._e()], 1)]
      }
    }], null, true)
  })], 1)], 1), _vm._v(" "), _c('content-script-edit-dialog', {
    attrs: {
      "value": _vm.contentScriptEditDialog,
      "item": _vm.pairingItem
    },
    on: {
      "saveClicked": _vm.saveContentScript
    },
    model: {
      value: (_vm.contentScriptEditDialog),
      callback: function($$v) {
        _vm.contentScriptEditDialog = $$v
      },
      expression: "contentScriptEditDialog"
    }
  }), _vm._v(" "), _c('post-link-update-modal', {
    attrs: {
      "value": _vm.postLinkUpdateDialog,
      "item": _vm.pairingItem
    },
    on: {
      "saveClicked": _vm.savePostLink
    },
    model: {
      value: (_vm.postLinkUpdateDialog),
      callback: function($$v) {
        _vm.postLinkUpdateDialog = $$v
      },
      expression: "postLinkUpdateDialog"
    }
  }), _vm._v(" "), _c('table-cols-show-hide-modal', {
    attrs: {
      "title": "Creator Concept Columns",
      "items": _vm.tableColsItems
    },
    on: {
      "updated": _vm.updateTableCols
    },
    model: {
      value: (_vm.colSettingsDialog),
      callback: function($$v) {
        _vm.colSettingsDialog = $$v
      },
      expression: "colSettingsDialog"
    }
  }), _vm._v(" "), (_vm.viewContentScriptsData) ? _c('view-creator-concept-modal-dialog', {
    attrs: {
      "value": _vm.viewcontentScriptModalDialog,
      "data": _vm.viewContentScriptsData
    },
    model: {
      value: (_vm.viewcontentScriptModalDialog),
      callback: function($$v) {
        _vm.viewcontentScriptModalDialog = $$v
      },
      expression: "viewcontentScriptModalDialog"
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-concept-link"
    },
    domProps: {
      "value": _vm.conceptFormLink
    }
  }), _vm._v(" "), _c('v-snackbar', {
    model: {
      value: (_vm.copySucceeded),
      callback: function($$v) {
        _vm.copySucceeded = $$v
      },
      expression: "copySucceeded"
    }
  }, [_vm._v("\n    Copied to Clipboard!\n    "), _c('v-btn', {
    attrs: {
      "color": "blue",
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.copySucceeded = false
      }
    }
  }, [_vm._v("\n      Close\n    ")])], 1), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "id": "copy-concept-link"
    },
    domProps: {
      "value": _vm.conceptFormLink
    }
  }), _vm._v(" "), _c('loading', {
    attrs: {
      "active": _vm.isLoading,
      "can-cancel": false,
      "is-full-page": true,
      "loader": "bars",
      "background-color": "#000",
      "color": "secondary",
      "width.number": "180",
      "height.number": "180"
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05d5a88a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pairing/CreatorConcept/DataTable.vue
// module id = 1980
// module chunks = 0